// extracted by mini-css-extract-plugin
module.exports = {"button":"GlobalSearch_button__2tnLf","content":"GlobalSearch_content__26Olc"};